// extracted by mini-css-extract-plugin
export default {"phoneFrame":"VideoMovil_phoneFrame__Zm1gw","phoneScreen":"VideoMovil_phoneScreen__D6vnc","notch":"VideoMovil_notch__EUl6V","playButton":"VideoMovil_playButton__4PfW7"};